import { apiBasePath } from './services/BaseUrl';
import { apiUrl } from '../utils/api';

const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getCoresignalCandidateList: build.query({
      query: ({ prompt, keyword,page }) => {
        const params = { prompt };
        if (keyword) {
          params.keyword = keyword; // Already stringified in the component
        }
        if (page) {
          params.page = page;
        }
        return {
          url: `${apiUrl.candidate}coresignal-collect/`,
          params
        };
      },
    }),
    getCoresignalCandidateListById: build.query({
      query: (id) => ({
        url: `${apiUrl.candidate}coresignal-collect/${id}/`,
      }),
    }),
    postCoresignalCandidateData: build.mutation({
      query: (data) => ({
        url: `${apiUrl.candidate}coresignal/status/`,
        method: 'POST',
        body: data,
      }),
    }),
    sendCandidateEmail: build.mutation({
      query: (data) => ({
        url: `${apiUrl.candidate}send-candidate-email/`,
        method: 'POST',
        body: data,
      }),
    }),
    getCandidateEmail: build.query({
      query: (id) => ({
        url: `${apiUrl.candidate}send-candidate-email/${id}`,
      }),
    }),
    generateEmailReply: build.mutation({
      query: (data) => ({
        url: `${apiUrl.candidate}generate-email-reply/`,
        method: 'POST',
        body: data,
      }),
    }),
    getCoresignalCandidateStatus: build.query({
      query: () => {
        const token = localStorage.getItem('access_token');
        return {
          url: `${apiUrl.candidate}coresignal/status/`,
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        };
      },
    }),
    getCoresignalCandidateViewed: build.query({
      query: () => {
        const token = localStorage.getItem('access_token');
        return {
          url: `${apiUrl.candidate}visited-candidates/`,
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        };
      },
    }),
    getCoresignalSearchPromantGenerate: build.query({
      query: (id) => {
        const token = localStorage.getItem('access_token');
        return {
          url: `${apiUrl.candidate}generate-candidate-search/${id}/`,
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        };
      },
    }),
    getCoresignalCandidateScrongin: build.query({
      query: ({ jobId, candidateId }) => {
        // Ensure we have valid IDs before making the request
        const validJobId = jobId?.id || jobId;
        if (!validJobId || !candidateId) {
          console.error('Invalid parameters for getCoresignalCandidateScrongin:', { jobId, candidateId });
          throw new Error('Both jobId and candidateId are required');
        }
        
        const token = localStorage.getItem('access_token');
        return {
          url: `${apiUrl.candidate}corsignal-candidate-scrongin/${validJobId}/${candidateId}/`,
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        };
      },
    })
  }),
  overrideExisting: false,
});

export const {
  useGetCoresignalCandidateListQuery,
  useGetCoresignalCandidateListByIdQuery,
  usePostCoresignalCandidateDataMutation,
  useSendCandidateEmailMutation,
  useGetCandidateEmailQuery,
  useGenerateEmailReplyMutation,
  useGetCoresignalCandidateStatusQuery,
  useGetCoresignalCandidateViewedQuery,
  useGetCoresignalSearchPromantGenerateQuery,
  useGetCoresignalCandidateScronginQuery
} = extendedApi;
